export default {
  data() {
    return {
      //  比赛章程
      constitutionUrl:
        "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/competition_regulations.pdf",
      //  比赛诵材
        materialUrl:
        "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/15b7103e9d1c71e09264611df669ff29.pdf",
      //  比赛诵材
      scoringStandardUrl:
        "https://materialv3-1256597606.cos.ap-hongkong.myqcloud.com/chineserd/speech_2026/id/grading_criteria.pdf",
      //  app下载
      appUrl: "https://school.chineserd.com/#/download-student",
      // 赛事质询
      whatUrl: "https://wa.me/6281334941415",
      // h5banner
      h5BannerUrl: require(`@/assets/image/hodgepodge/h5banner_${this.$i18n.locale}.jpg`),
      // pcbanner
      pcBannerUrl: require(`@/assets/image/hodgepodge/pcbanner_${this.$i18n.locale}.jpg`),
    };
  },
  computed: {},
  components: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
